import { genericRoute } from 'utils/routeUtils';

import SnookerHomePage from './containers/SnookerHomePage';
import SnookerNav from './nav/SnookerNav';

export default genericRoute(SnookerHomePage, SnookerNav, 'snooker');



// WEBPACK FOOTER //
// ./modules/Snooker/routes.js